import { useState, useEffect } from 'react';
import api from './api';

// ── تخزين شعار/اسم التطبيق محلياً لتفادي "الفلاش" الفارغ عند فتح الصفحة ──
// localStorage مقسّم أصلاً حسب النطاق (origin) بالمتصفح، فكل نطاق فرعي
// (subdomain) بهذا المشروع متعدد المستأجرين يحصل تلقائياً على تخزينه الخاص
// بدون أي تداخل بين شعارات/أسماء الشبكات المختلفة.
const CACHE_KEY = 'app_config_cache_v1';

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return { app_logo: '', app_name: '' };
    const parsed = JSON.parse(raw);
    return { app_logo: parsed.app_logo || '', app_name: parsed.app_name || '' };
  } catch {
    return { app_logo: '', app_name: '' };
  }
}

function writeCache(app_logo, app_name) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ app_logo, app_name })); } catch {}
}

/**
 * يرجّع { appLogo, appName } — يبدأ فوراً بآخر قيمة معروفة من localStorage
 * (لو موجودة) بدل فراغ، فيظهر الشعار/الاسم مباشرة بدون تأخير محسوس حتى قبل
 * وصول رد /app-config، ثم يحدّثهما بصمت في الخلفية لو تغيّرا فعلياً.
 */
export function useAppConfig() {
  const cached = readCache();
  const [appLogo, setAppLogo] = useState(cached.app_logo);
  const [appName, setAppName] = useState(cached.app_name);

  useEffect(() => {
    api.get('/app-config').then(r => {
      const logo = r.data.app_logo || '';
      const name = r.data.app_name || '';
      if (logo) setAppLogo(logo);
      if (name) setAppName(name);
      if (logo || name) writeCache(logo || cached.app_logo, name || cached.app_name);
    }).catch(() => {});
    
  }, []);

  return { appLogo, appName };
}
